/**
 * @generated SignedSource<<548ad7281bba42e7f487aa49e666ea32>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateCustomFieldDefinitionInput = {
  key?: string | null;
  displayName?: string | null;
  readOnly?: boolean | null;
  type?: string | null;
  entityType?: string | null;
  avaRef?: number | null;
  currencyCode?: string | null;
  showOnOpportunityList?: boolean | null;
  showOnProjectList?: boolean | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type CreateCustomFieldDefinitionMutation$variables = {
  input: CreateCustomFieldDefinitionInput;
};
export type CreateCustomFieldDefinitionMutation$data = {
  readonly createCustomFieldDefinition: {
    readonly customFieldDefinition: {
      readonly node: {
        readonly id: string;
        readonly __typename: string;
        readonly key: string;
        readonly displayName: string;
        readonly entityType: string;
        readonly avaRef: number | null;
        readonly type: string;
        readonly readOnly?: boolean;
        readonly currencyCode?: string | null;
      } | null;
    } | null;
  } | null;
};
export type CreateCustomFieldDefinitionMutation$rawResponse = {
  readonly createCustomFieldDefinition: {
    readonly customFieldDefinition: {
      readonly node: {
        readonly id: string;
        readonly __typename: "TextCustomField";
        readonly key: string;
        readonly displayName: string;
        readonly entityType: string;
        readonly avaRef: number | null;
        readonly type: string;
        readonly readOnly: boolean;
      } | {
        readonly id: string;
        readonly __typename: "IntegerCustomField";
        readonly key: string;
        readonly displayName: string;
        readonly entityType: string;
        readonly avaRef: number | null;
        readonly type: string;
        readonly readOnly: boolean;
      } | {
        readonly id: string;
        readonly __typename: "DecimalCustomField";
        readonly key: string;
        readonly displayName: string;
        readonly entityType: string;
        readonly avaRef: number | null;
        readonly type: string;
        readonly readOnly: boolean;
      } | {
        readonly id: string;
        readonly __typename: "DateCustomField";
        readonly key: string;
        readonly displayName: string;
        readonly entityType: string;
        readonly avaRef: number | null;
        readonly type: string;
        readonly readOnly: boolean;
      } | {
        readonly id: string;
        readonly __typename: "BooleanCustomField";
        readonly key: string;
        readonly displayName: string;
        readonly entityType: string;
        readonly avaRef: number | null;
        readonly type: string;
        readonly readOnly: boolean;
      } | {
        readonly id: string;
        readonly __typename: "HyperlinkCustomField";
        readonly key: string;
        readonly displayName: string;
        readonly entityType: string;
        readonly avaRef: number | null;
        readonly type: string;
        readonly readOnly: boolean;
      } | {
        readonly id: string;
        readonly __typename: "CurrencyCustomField";
        readonly key: string;
        readonly displayName: string;
        readonly entityType: string;
        readonly avaRef: number | null;
        readonly type: string;
        readonly readOnly: boolean;
        readonly currencyCode: string | null;
      } | {
        readonly id: string;
        readonly __typename: string;
        readonly key: string;
        readonly displayName: string;
        readonly entityType: string;
        readonly avaRef: number | null;
        readonly type: string;
      } | null;
    } | null;
  } | null;
};
export type CreateCustomFieldDefinitionMutation = {
  variables: CreateCustomFieldDefinitionMutation$variables;
  response: CreateCustomFieldDefinitionMutation$data;
  rawResponse: CreateCustomFieldDefinitionMutation$rawResponse;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "readOnly",
  "storageKey": null
},
v2 = [
  (v1/*: any*/)
],
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateCustomFieldDefinitionPayload",
    "kind": "LinkedField",
    "name": "createCustomFieldDefinition",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CustomFieldDefinitionV2TypeEdge",
        "kind": "LinkedField",
        "name": "customFieldDefinition",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "key",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "entityType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "avaRef",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v2/*: any*/),
                "type": "TextCustomField",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v2/*: any*/),
                "type": "IntegerCustomField",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v2/*: any*/),
                "type": "DecimalCustomField",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v2/*: any*/),
                "type": "DateCustomField",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v2/*: any*/),
                "type": "BooleanCustomField",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v2/*: any*/),
                "type": "HyperlinkCustomField",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "currencyCode",
                    "storageKey": null
                  }
                ],
                "type": "CurrencyCustomField",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateCustomFieldDefinitionMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateCustomFieldDefinitionMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "4350456594cf2177ade31ab8f79e60ef",
    "id": null,
    "metadata": {},
    "name": "CreateCustomFieldDefinitionMutation",
    "operationKind": "mutation",
    "text": "mutation CreateCustomFieldDefinitionMutation(\n  $input: CreateCustomFieldDefinitionInput!\n) {\n  createCustomFieldDefinition(input: $input) {\n    customFieldDefinition {\n      node {\n        id\n        __typename\n        key\n        displayName\n        entityType\n        avaRef\n        type\n        ... on TextCustomField {\n          readOnly\n        }\n        ... on IntegerCustomField {\n          readOnly\n        }\n        ... on DecimalCustomField {\n          readOnly\n        }\n        ... on DateCustomField {\n          readOnly\n        }\n        ... on BooleanCustomField {\n          readOnly\n        }\n        ... on HyperlinkCustomField {\n          readOnly\n        }\n        ... on CurrencyCustomField {\n          readOnly\n          currencyCode\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "daff5f21bd5862ec49a94e12bc7b1c57";

export default node;
